import { render } from "./EventForm.vue?vue&type=template&id=5ed006e1&scoped=true"
import script from "./EventForm.vue?vue&type=script&lang=js"
export * from "./EventForm.vue?vue&type=script&lang=js"

import "./EventForm.vue?vue&type=style&index=0&id=5ed006e1&scoped=true&lang=css"
import "./EventForm.vue?vue&type=style&index=1&id=5ed006e1&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed006e1"]])

export default __exports__